import { Form, NumberBox, Popup, SelectBox, TextArea, TextBox } from 'devextreme-react';
import { EmptyItem, SimpleItem } from 'devextreme-react/form';
import { Component } from 'react';
import TarikhPicker from '../TarikhPicker';
import { apiPostP } from '../../GanjiTools';
import TarikhTimePicker from '../TarikhTimePicker';
import Uploader from '../Uploader';
import PrepareAuxFile, { AuxFile } from './AuxFile';
import { Format } from 'devextreme-react/number-box';
import FileUploadScanner from '../utils/FileUploadScanner';
import VirtualScannerComponent from '../utils/VirtualScannerComponent';
import ScanButton from '../utils/ScanButton';

class Deal extends Component {
    state = {
        row: this.props.row ?? {},
        companies: [],
        truckOwners: [],
        focusedDeal: this.props.restricted ? this.props.focusedDeal : this.props.row,
    }

    onDealSavedOrCanceled = saved => {
        AuxFile.manageTemporaries('Deal', saved === false ? 'remove' : 'keep', this.state.focusedDeal?.id);
        this.props.onDealSavedOrCanceled?.(saved);
    }

    componentDidMount() {
        if (this.props.restricted) {
            let truckOwners = this.props.truckOwner ? [this.props.truckOwner] : [];
            let customers = this.props.customer ? [this.props.customer] : [];
            let tankers = this.props.tanker ? [this.props.tanker] : [];
            let row = this.props.row;
            const type = row?.dealtype;

            if (!(type >= 0 && type < 4)) {
                window.notif('row.dealtype property should been evaluated in restricted mode.');
                return;
            }

            this.setState({ truckOwners, customers, tankers });
            return;
        }

        //console.log('Deal is mounted: ', this.props.row);
        Promise.all([
            apiPostP('/api/dyna/rowsAsLookup/truckOwner', {}),
            apiPostP('/api/dyna/rowsAsLookup/customer', {}),
            apiPostP('/api/dyna/rowsAsLookup/tanker', {})
        ]).then(res => {
            let _error = '';
            if (res?.length !== 3) {
                res = [[], [], []];
                _error = 'No response';
            }
            let truckOwners = res[0]?.list ?? [];
            let customers = res[1]?.list ?? [];
            let tankers = res[2]?.list ?? [];

            let error = _error + (res[0]?.error ?? '') + (res[1]?.error ?? '') + (res[2]?.error ?? '');

            if (error?.length > 0) {
                window.notif(error);
                return;
            }
            this.state.row.fk_tanker = this.props.tanker?.id;
            this.state.row.fk_customer = this.props.customer?.id;
            this.state.row.fk_truckOwner = this.props.truckOwner?.id;

            this.setState({ truckOwners, customers, tankers });
        }).catch(window.notif)
    }
    static types = [
        { id: 0, summary: 'پرداخت به تانکر' },
        { id: 1, summary: 'پرداخت به ماشین دار' },
        { id: 2, summary: 'خرید کالا' },
        { id: 3, summary: 'فروش کالا' },
    ];

    render() {
        let type = this.props.row?.dealtype;
        //console.log('deal type: ', type);

        return (
            <div>
                <Form colCount={60} rtlEnabled labelLocation={window.mView ? 'top' : 'left'}
                >
                    {type === 0 && // !this.props.restricted &&
                        <SimpleItem colSpan={30} label={{ text: 'تانکر' }}
                        >
                            <SelectBox items={this.state.tankers} valueExpr='id' displayExpr='summary' rtlEnabled
                                value={this.props.tanker?.id ?? this.state.row.fk_tanker}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.fk_tanker = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }
                    {type === 1 && //!this.props.restricted &&
                        <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'صاحب ماشین' }}
                        >
                            <SelectBox items={this.state.truckOwners} valueExpr='id' displayExpr='summary' rtlEnabled
                                value={this.props.truckOwner?.id ?? this.state.row.fk_truckowner}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.fk_truckowner = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }
                    {type === 2 &&
                        <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'کالا' }}
                        >
                            <TextBox rtlEnabled
                                value={this.state.row.ware}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.ware = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }
                    {(type === 2 || type === 3) && //!this.props.restricted &&
                        <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: type === 3 ? 'خریدار' : 'فروشنده' }}
                        >
                            <SelectBox items={this.state.customers} valueExpr='id' displayExpr='summary' rtlEnabled
                                value={this.props.customer?.id ?? this.state.row.fk_customer}
                                //onValueChanged={e => this.setState({ row: { ...this.state.row, fK_ShareHolder: e.value } })}
                                onValueChanged={e => { this.state.row.fk_customer = e.value; this.forceUpdate(); }}
                            />
                        </SimpleItem>
                    }

                    <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'مبلغ' }}>
                        <NumberBox min={0} format={{ precision: 0, useCurrencyAccountingStyle: true }}
                            value={this.state.row.val}
                            onValueChanged={e => { this.state.row.val = e.value; this.forceUpdate(); }}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={window.mView ? 60 : 30} label={{ text: 'تاریخ' }}>
                        <TarikhPicker
                            value={this.state.row.tarikh}
                            onValueChanged={e => { this.state.row.tarikh = e; this.forceUpdate(); }}
                        />
                    </SimpleItem>
                    {
                        (type !== 2 /*|| this.props.restricted*/) && <EmptyItem colSpan={30} />
                    }

                    <SimpleItem colSpan={60} label={{ text: 'شرح' }}>
                        <TextArea
                            value={this.state.row.comment}
                            onValueChanged={e => { this.state.row.comment = e.value; this.forceUpdate(); }}
                        />
                    </SimpleItem>

                    {/* <SimpleItem colSpan={30}>
                        <Uploader selectButtonText={'بارگذاری اسناد...'}
                            subPath={AuxFile.getTempPath('Deal', this.state.row?.id)}
                        />
                    </SimpleItem>

                    <SimpleItem colSpan={30}>
                        <ScanButton subPath={AuxFile.getTempPath('Deal', this.state.row?.id)} />
                    </SimpleItem> 
                    */}

                    <SimpleItem colSpan={60}>
                        <PrepareAuxFile table='Deal' rowId={this.state.row?.id} />
                    </SimpleItem>
                </Form>
            </div >
        );
    }
}

export default Deal;
